import { availabilityTimezone } from './availabilityDateTime';

export function bookableSlotTime(startsAt: string, timezone?: string | null) {
  const zone = availabilityTimezone(timezone);
  const date = new Date(startsAt);
  const dateParts = new Intl.DateTimeFormat('en-CA', {
    timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(date);
  const part = (type: string) => dateParts.find((value) => value.type === type)?.value;
  const day = new Intl.DateTimeFormat('en-US', {
    timeZone: zone, weekday: 'short', month: 'short', day: 'numeric',
  }).format(date);
  const time = new Intl.DateTimeFormat('en-US', {
    timeZone: zone, hour: 'numeric', minute: '2-digit',
  }).format(date);
  const zoneLabel = new Intl.DateTimeFormat('en-US', {
    timeZone: zone, timeZoneName: 'short',
  }).formatToParts(date).find((value) => value.type === 'timeZoneName')?.value || zone;
  return { key: `${zone}:${part('year')}-${part('month')}-${part('day')}`, day, time, zoneLabel };
}
